import React from 'react';

function InvoiceStatusLabelCase(productType) {
	switch(productType) {
		case "anew": {
			return "Mới"
		}
		case "bdelay" : {
			return "Chờ Xuất"
		}
		case "cprocess" : {
			return "Tiến Hành"
		}
		case "dfinish" : {
			return "Hoàn Tất"
		}
	}
}

class VATStatusSelect extends React.Component {
    constructor(props) {
			super(props);
    }
    render() {
			const {vat_status_selected, onVATStatusSelect} = this.props;
			return(
				<React.Fragment>
					<div style={{float: 'right'}} className="btn-group">
						<button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
							{InvoiceStatusLabelCase(vat_status_selected)}
						</button>
						<div className="dropdown-menu" x-placement="bottom-start">
							<a onClick={() => onVATStatusSelect("anew")} className="dropdown-item">Mới</a>
							<a onClick={() => onVATStatusSelect("bdelay")} className="dropdown-item">Chờ Xuất</a>
							<a onClick={() => onVATStatusSelect("cprocess")} className="dropdown-item">Tiến Hành Xuất</a>
							<a onClick={() => onVATStatusSelect("dfinish")} className="dropdown-item">Hoàn Tất</a>
						</div>
					</div>
				</React.Fragment>
			)
    }

}


export default VATStatusSelect;